import { Component, Input, Output, EventEmitter } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as moment from 'moment';
import { CrudApiProvider } from '../../providers/crud-api/crud-api';
import { ToolsProvider } from '../../providers/tools/tools';
import { UserProvider } from '../../providers/user/user';

@Component({
  selector: 'app-trip-stats',
  templateUrl: 'trip-stats.html',
})
export class TripStatsComponent {
  log = debug('app:TripStatsComponent');

  @Input() trip: any = {};

  timeInterval = null;
  subs: any = [];

  totalTime = null;
  totalMiles = null;

  constructor(
    public crudApi: CrudApiProvider,
    public tools: ToolsProvider,
    public user: UserProvider
  ) {}

  ngOnInit() {
    this.log('Hello TripStatsComponent Component', this.trip);

    if (!_.get(this.trip, 'dates.completed')) {
      this.setDriveTime();
      this.timeInterval = setInterval(() => {
        this.setDriveTime();
      }, 10000);

      this.subs.push(
        this.tools.on('endingRoute', () => {
          clearInterval(this.timeInterval);
        })
      );
    } else {
      this.setDriveTimeCompletedTrip();
    }
  }

  ngOnDestory() {
    clearInterval(this.timeInterval);
  }

  private setDriveTime() {
    const t: any = this.user.get('currentTrip');
    this.log('updating time', t);
    let duration = null;
    const now = moment();
    const created = moment(_.get(t, 'dates.created'));

    this.totalTime = Math.abs(now.diff(created, 'seconds'));
    if (_.get(t.tripStats, 'totalMiles') <= 10) {
      this.log('totalMiles rounding ', this.totalMiles);
      this.totalMiles = _.round(_.get(t.tripStats, 'totalMiles'), 2);
    } else {
      this.totalMiles = _.round(_.get(t.tripStats, 'totalMiles'));
    }
    this.log('tripStats time', this.totalTime);
    this.log('tripStats miles', this.totalMiles);
  }

  private setDriveTimeCompletedTrip() {
    const t: any = _.get(this, 'trip');
    this.log('updating time', t);
    let duration = null;
    const completed = moment(_.get(t, 'dates.completed'));
    const created = moment(_.get(t, 'dates.created'));

    this.totalTime = Math.abs(completed.diff(created, 'seconds'));
    if (_.get(t.tripStats, 'totalMiles') <= 10) {
      this.log('totalMiles rounding ', this.totalMiles);
      this.totalMiles = _.round(_.get(t.tripStats, 'totalMiles'), 2);
    } else {
      this.totalMiles = _.round(_.get(t.tripStats, 'totalMiles'));
    }
    this.log('tripStats time', this.totalTime);
    this.log('tripStats miles', this.totalMiles);
  }
}



// WEBPACK FOOTER //
// ./src/components/trip-stats/trip-stats.ts